import { memo, RefObject } from 'react';
import { MdContentCopy } from 'react-icons/md';
import { FaCheck } from 'react-icons/fa';
import cn from 'classnames';

import { OResponsiveModal } from '@src/shared';
import { BRAND } from '@src/constants/room.constants';

import { SOCIAL_LINKS } from './shareRoomModal.constants';
import useShareRoomModal from './useShareRoomModal';
import styles from './shareRoomModal.module.scss';

interface IShareRoomModalProps {
  shareButtonRef: RefObject<HTMLDivElement> | null;
}

const ShareRoomModal = ({ shareButtonRef }: IShareRoomModalProps) => {
  const { isOpen, isCopied, isMobileDevice, isSupported, handleClose, handleCopyLink, handleSocialClick } =
    useShareRoomModal(shareButtonRef);

  if (!isSupported) return null;

  return (
    <OResponsiveModal
      title={BRAND.app.name}
      isOpen={isOpen}
      onClose={handleClose}
      hasBackdrop
      oModalProps={{
        classes: {
          header: styles.modalHeader,
          container: styles.modalContainer,
          title: styles.modalTitle,
          body: styles.modalBody,
          closeIconWrapper: styles.closeIconWrapper,
        },
      }}
      modalClasses={{
        header: styles.modalHeader,
        title: styles.modalTitle,
        container: styles.modalContainer,
        body: styles.modalBody,
        closeIconWrapper: styles.closeIconWrapper,
      }}
    >
      <div className={cn({ [styles.responsiveModalContainer]: isMobileDevice })}>
        <div className={styles.root}>
          <div className={styles.socialRow}>
            {SOCIAL_LINKS.map(({ name, icon: Icon, getUrl, color }) => (
              <button key={name} className={styles.socialButton} onClick={() => handleSocialClick(getUrl)}>
                <div className={styles.socialIcon} style={{ backgroundColor: color }}>
                  <Icon size={20} color="#fff" />
                </div>
                <span className={styles.socialLabel}>{name}</span>
              </button>
            ))}
          </div>

          <button className={cn(styles.copyButton, { [styles.copied]: isCopied })} onClick={handleCopyLink}>
            {isCopied ? (
              <>
                <FaCheck size={14} />
                <span>Copied Successfully</span>
              </>
            ) : (
              <>
                <MdContentCopy size={14} style={{ transform: 'rotate(180deg)' }} />
                <span>Copy link</span>
              </>
            )}
          </button>
        </div>
      </div>
    </OResponsiveModal>
  );
};

export default memo(ShareRoomModal);
